import React from "react";
import { serviceInclud } from "../../../types/packageFlowModel";

interface DropDownProps {
  serviceInclude?: serviceInclud[];
  count?: number;
}

const DropDown: React.FC<DropDownProps> = ({ serviceInclude }) => {
  return (
    <>
      <div className="visa-tooltip bg-white border rounded p-2 shadow-sm mt-1">
        {/* {serviceInclude?.map((step, index) => ( */}
        {serviceInclude
          ?.filter((step) => step.includes === 1)
          .map((step, index) => (
            <div
              key={index}
              className={`visa-step-item ${
                index === serviceInclude.length - 1 ? "" : "border-bottom"
              } py-2 d-flex justify-content-between align-items-center`}
            >
              <div className="visa-step-label d-flex align-items-center gap-2">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.4908 1.76719C12.6073 2.41181 13.536 3.33682 14.185 4.45067C14.8341 5.56452 15.181 6.82857 15.1914 8.11769C15.2019 9.40682 14.8754 10.6763 14.2444 11.8005C13.6134 12.9247 12.6998 13.8646 11.5939 14.5271C10.488 15.1897 9.22828 15.552 7.93938 15.5781C6.65048 15.6041 5.37711 15.2931 4.24533 14.6759C3.11356 14.0586 2.16262 13.1564 1.48666 12.0587C0.810697 10.961 0.433151 9.70571 0.391396 8.41722L0.387695 8.1774L0.391396 7.93757C0.43285 6.65922 0.804838 5.41343 1.47109 4.32165C2.13735 3.22986 3.07514 2.32934 4.19303 1.70789C5.31092 1.08643 6.57077 0.765242 7.84974 0.775635C9.12872 0.786028 10.3832 1.12765 11.4908 1.76719ZM10.5337 6.17365C10.4063 6.04621 10.2367 5.96965 10.0568 5.95833C9.87691 5.94702 9.69908 6.00174 9.55666 6.11222L9.48708 6.17365L7.04957 8.61042L6.09248 7.65407L6.0229 7.59263C5.88048 7.48223 5.70267 7.42758 5.52282 7.43893C5.34298 7.45028 5.17345 7.52684 5.04602 7.65426C4.9186 7.78169 4.84204 7.95122 4.83069 8.13106C4.81934 8.31091 4.87399 8.48872 4.98439 8.63115L5.04583 8.70072L6.52625 10.1811L6.59583 10.2426C6.72564 10.3433 6.88527 10.398 7.04957 10.398C7.21388 10.398 7.37351 10.3433 7.50332 10.2426L7.5729 10.1811L10.5337 7.22031L10.5952 7.15073C10.7056 7.00831 10.7604 6.83047 10.7491 6.65058C10.7377 6.47069 10.6612 6.30111 10.5337 6.17365Z"
                    fill="#029002"
                  />
                </svg>

                <span
                  className={
                    step.includes
                      ? "visa-complete ff-normal font-12"
                      : "text-main ff-normal font-12"
                  }
                  dangerouslySetInnerHTML={{ __html: step.title}}
                >
                </span>
              </div>
              <div className="text-end">
                {/* <span className="visa-price-old font-12 text-black-50 me-1">
                                                AED {step.originalPrice}
                                              </span> */}
                <span className="visa-price-new font-13 text-black">
                  <span className="ff-currency ff-medium  font-16"></span>
                  {step.PriceAmount.toFixed(2)}
                </span>
              </div>
            </div>
          ))}
      </div>
      <style>{`
  .capsule-wrapper {
  position: relative;
  display: inline-block;
}

.visa-tooltip {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;
  z-index: 1000;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px;
  width: 100%;
  max-width: 500px;
  min-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.capsule-tooltip:hover .visa-tooltip {
  display: block !important;
}

.visa-step-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  gap: 8px;
  border-bottom: 1px solid #eee;
}

.visa-step-item:last-child {
  border-bottom: none;
}

.visa-step-label {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 6px;
  min-width: 0;
}

.visa-step-label svg {
  flex-shrink: 0;
}

.visa-step-label span {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  display: inline-block;
}

.text-end {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  flex-shrink: 0;
}

.visa-price-old {
  text-decoration: line-through;
  color: #999;
  font-size: 12px;
}

.visa-price-new {
  font-weight: 600;
  font-size: 13px;
  color: #000;
}

/* Responsive tweaks */
@media (max-width: 576px) {
  .visa-tooltip {
    max-width: 90vw;
    padding: 10px;
  }

  .visa-step-label span {
    max-width: 120px;
  }
}


`}</style>
    </>
  );
};

export default DropDown;
